module.exports = __webpack_public_path__ + "static/enterprise-application-and-solutions-b9bcd06f146b42cc189623f25b09950d.jpg";